import React from 'react'

export default function ImageIco() {
  return (
    <div>
      <svg width="24" height="24" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="12.5" cy="12.7491" rx="12.5" ry="12.5089" fill="#1D56C6"/>
<path d="M17.5885 5.99023H7.65966C6.8763 5.99023 6.24126 6.62527 6.24126 7.40864V17.3375C6.24126 18.1208 6.8763 18.7559 7.65966 18.7559H17.5885C18.3718 18.7559 19.0069 18.1208 19.0069 17.3375V7.40864C19.0069 6.62527 18.3718 5.99023 17.5885 5.99023Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.1419 10.9538C10.7294 10.9538 11.2057 10.4775 11.2057 9.88997C11.2057 9.30245 10.7294 8.82617 10.1419 8.82617C9.55434 8.82617 9.07806 9.30245 9.07806 9.88997C9.07806 10.4775 9.55434 10.9538 10.1419 10.9538Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M19.0069 14.5011L15.4609 10.9551L7.65965 18.7563" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    </div>
  )
}
